import $ from 'jquery';
import _ from 'ext:lodash';
import Cookies from 'cookies-js';
import AddMembers from './AddMembers';
import constants from 'lib/constants';
import UrlUtils from 'lib/url-utils';

$(() => {
	var mount = $('#nmoAddMembers');
	var addMembers;

	if(mount.length) {
		// grab cookie info
		// check for stored referral information
		const storedReferralInfo = Cookies.get(constants.memberReferralCookieName);
		let referralCode = '';
		let referralSource = '';
		if(storedReferralInfo !== null && typeof storedReferralInfo !== 'undefined' && storedReferralInfo.length > 0) {
			let memberReferralInfo = storedReferralInfo.split('|');
			referralCode = memberReferralInfo[0];
			referralSource = memberReferralInfo[1];
		}

		//check for stored corporate promotion information
		const storedPromotionInfo = Cookies.get(constants.cookieCorpMembership);
		let promotionName = '';
		if(storedPromotionInfo !== null && typeof storedPromotionInfo !== 'undefined' && storedPromotionInfo.length > 0) {
			promotionName = storedPromotionInfo.split('|')[0];
		}

		addMembers = new AddMembers(mount[0], referralCode, referralSource, promotionName);

		let clubIdParam = UrlUtils.getUrlParameter('clubId');
		addMembers.initialize(clubIdParam);
	}
});
